module.exports = __webpack_public_path__ + "img/130917.5e8fdd76.svg";